module.exports = __webpack_public_path__ + "static/media/correioBrasiliense.2da4cb5b.png";